angular.module('bb.util').component('bbDisabled', {
  transclude: true,
  bindings: {
    disable: '<',
  },
  controller: DisableController,
  controllerAs: 'vm',
  template: `
    <div style="postition:relative;box-sizing: border-box;">
        <div style="z-index: 5;" ng-class="{'bb-disabled': vm.disable}">
        </div>
        <ng-transclude style="z-index:1"></ng-transclude>
    </div>
    `,
});

DisableController.$inject = ['$scope'];
function DisableController($scope) {}

export {};
